import {useState,useEffect} from "react";
import { Link ,useLocation, useNavigate } from "react-router-dom";
import CtntTop5InqApi from "Apis/CtntTop5InqApi";
import GameSvcCtntPstdLstInqApi from "Apis/GameSvcCtntLstInqApi";
import GameSvcCtntLstTopFixInqApi from "Apis/GameSvcCtntLstTopFixInqApi";
import MgpStore from "Stores/Store";
import Pagination from "react-js-pagination";
import UseLangLstQuery from "Apis/LangTxtInqApi";
import "Assets/css/Ctnt.css";
import ApiError from "Utils/ApiError";
const CtntPstdLstUi = ({gameSvcCd,ctntKindCd,ctntCtgrCdName,LstType}:any) => {
    const {isLoading,error,data: langData}:any = UseLangLstQuery();
    const navigate = useNavigate();
    const location = useLocation();
    
    const [pageState, setPageState] = useState(1);
    const [onePageSizeState,setOnePageSizeState] = useState();
    const [totPstdCntState,setTotPstdCntState] = useState(1);
    const [ctntTypeState,setctntTypeState] = useState<string|null>();
    
    // URL 파라미터 실시간 추출 (메뉴 변경 및 페이지 변경 감지용)
    const getCurrentParams = () => {
        const currentParams = new URLSearchParams(location.search);
        return {
            currentGameSvcCd: currentParams.get("gameSvcCd") || gameSvcCd,
            currentCtntCtgrCd: currentParams.get("ctntKindCd") || ctntKindCd,
            currentPage: parseInt(currentParams.get("page") || "1")
        };
    };
    
    const handlePageChange = (newPage:any) => {
        const { currentGameSvcCd, currentCtntCtgrCd } = getCurrentParams();
        
        // URL 파라미터 업데이트
        const newParams = new URLSearchParams(location.search);
        newParams.set("page", newPage.toString());
        navigate(`${location.pathname}?${newParams.toString()}`, { replace: true });
    };
    
    // 기존 파라미터 로직 (초기값 설정용)
    const serchParamsFunc = () => {
        return new URLSearchParams(location.search);
    }
    let query = serchParamsFunc();
    let getGameSvcCd = query.get("gameSvcCd");
    let getctntKindCd = query.get("ctntKindCd");
    
    if(getGameSvcCd != null){
        gameSvcCd = getGameSvcCd;
        ctntKindCd = getctntKindCd;
    }

    if(gameSvcCd == null) {
        gameSvcCd = location.state?.gameSvcCd;
    }
    if(ctntKindCd == null) {
        ctntKindCd = location.state?.ctntKindCd;
    }
    
    const [ctntCtxtState,setCtntCtxtState] = useState<any>();
    const [ctntKindCdState,setCtntKindCdState] = useState<any>();
    const [topFixCtntState,setTopFixCtntState] = useState<any>();
    
    useEffect(()=>{
        const { currentGameSvcCd, currentCtntCtgrCd, currentPage } = getCurrentParams();
        console.log("API 호출 - gameSvcCd:", currentGameSvcCd, "ctntKindCd:", currentCtntCtgrCd, "page:", currentPage);
        
        // 페이지 상태 동기화
        setPageState(currentPage);
        
        // 일반 게시글 목록 조회
        GameSvcCtntPstdLstInqApi(currentGameSvcCd, currentCtntCtgrCd, currentPage,"",null).then((resp)=> {
            switch(resp.apiHdr.code){
                case "GAME0000":
                    setCtntCtxtState(resp.apiBody.ctntLst);
                    setCtntKindCdState(resp.apiBody.ctntLst)
                    setPageState(resp.apiBody.nowPageNo)
                    setOnePageSizeState(resp.apiBody.onePageSize)
                    setTotPstdCntState(resp.apiBody.totCnt)
                    setTopFixCtntState(resp.apiBody.ctntTopFixLst);
                    break;
                default:
                    ApiError(langData,resp.apiHdr.code);
                    break;
            }
        })

    }, [location.search, MgpStore.getState().LangSetState.Lang]);
    
    const [ctntCtgrCdCd,setctntCtgrCdCd] = useState(ctntKindCd);
    return(
        <div className="BgW">
        <div className="csMainBnr newsMainBnr"><h1>{langData&&langData.GLB__COMM_TITL_LBL_00}</h1><p>NEWS</p></div>
        <div  className="trmsContainer ctntCtgr">
            <h1 className="ctntCtgrTitl">
                {ctntKindCd == "PNOT" && langData?.GLB_PNOT_LST_TITL_00}
                {ctntKindCd == "UPDT" && langData?.GLB_UPDT_LST_TITL_00}
                {ctntKindCd == "EVNT" && langData?.GLB_EVNT_LST_TITL_00}
            </h1>
            <div className="trmsCtgrMenu">
                <ul>
                    <li className={ctntKindCd == "PNOT"?"active":""}>
                        <Link to={`/ctnt/ctntLst?gameSvcCd=${gameSvcCd}&ctntKindCd=PNOT&lang=${MgpStore.getState().LangSetState.Lang}`}>
                            <p>{langData&&langData.GLB_PNOT_LST_TITL_00}</p>
                            {/* 공지사항 */}
                        </Link>
                    </li>
                    <li className={ctntKindCd == "UPDT"?"active":""}>
                        <Link to={`/ctnt/ctntLst?gameSvcCd=${gameSvcCd}&ctntKindCd=UPDT&lang=${MgpStore.getState().LangSetState.Lang}`}>
                            <p>{langData&&langData.GLB_UPDT_LST_TITL_00}</p>
                            {/* 업데이트 */}
                        </Link>
                    </li>
                    <li className={ctntKindCd == "EVNT"?"active":""}>
                        <Link to={`/ctnt/ctntLst?gameSvcCd=${gameSvcCd}&ctntKindCd=EVNT&lang=${MgpStore.getState().LangSetState.Lang}`}>
                            <p>{langData&&langData.GLB_EVNT_LST_TITL_00}</p>
                            {/* 이벤트 */}
                        </Link>
                    </li>
                </ul>
            </div>
        </div>
        <div className="ctntLstWrap ctntPstdLstWrap">
            {/* <div className={`${ctntCtgrCdCd}TitlWrap ctntLstTitlWrap`}>
                <h2>{ctntCtgrCdName}</h2>
                <img src={process.env.PUBLIC_URL+'/images/'+ctntCtgrCdCd+"TitlImg.png"} alt="" />
            </div> */}
            <div className="ctntLstContentsWrap">
                {(topFixCtntState && topFixCtntState.length > 0) || (ctntCtxtState && ctntCtxtState.length > 0) ? 
                    <>
                    <ul className="ctntLstContentUl">
                        {/* 상단 고정 게시글 */}
                        {topFixCtntState && topFixCtntState.map((key:any) => {
                            const currentParams = getCurrentParams();
                            return (
                            <li className="topFixCtnt" key={key.ctntSno}>
                                <Link to={`/ctnt/ctntCtxt?gameSvcCd=${key.gameSvcCd}&ctntKindCd=${currentParams.currentCtntCtgrCd}&ctntSno=${key.ctntSno}&lang=${MgpStore.getState().LangSetState.Lang}`}
                                        state={{ 
                                            returnUrl: `${location.pathname}${location.search}`,
                                            listPage: currentParams.currentPage,
                                            listCategory: currentParams.currentCtntCtgrCd
                                        }}>
                                    <p className="ctntTitlTxt">
                                        <span className="">&#x1F4CC;</span>
                                        {key.ctntTitl}
                                    </p>
                                    <div className="ctntMetaInfo">
                                        <p className="vwrCnt"><i className="eye"></i>{key.vwrCnt}</p>
                                        <p className="ctntDate">{key.aplyStrtDtime}</p>
                                    </div>
                                </Link>
                            </li>
                            )
                        })}
                        {/* 일반 게시글 */}
                        {ctntCtxtState&&ctntCtxtState.map((key:any) => {
                            const currentParams = getCurrentParams();
                            return (
                            <li key={key.ctntSno}>
                                <Link to={`/ctnt/ctntCtxt?gameSvcCd=${key.gameSvcCd}&ctntKindCd=${currentParams.currentCtntCtgrCd}&ctntSno=${key.ctntSno}&lang=${MgpStore.getState().LangSetState.Lang}`}
                                        state={{ 
                                            returnUrl: `${location.pathname}${location.search}`,
                                            listPage: currentParams.currentPage,
                                            listCategory: currentParams.currentCtntCtgrCd
                                        }}>
                                    <p className="ctntTitlTxt">{key.ctntTitl}</p>
                                    <div className="ctntMetaInfo">
                                        <p className="vwrCnt"><i className="eye"></i>{key.vwrCnt}</p>
                                        <p className="ctntDate">{key.aplyStrtDtime}</p>
                                    </div>
                                </Link>
                            </li>
                            )
                        })}
                    </ul>
                    <div className="ctntPageWrap">
                        <Pagination
                            activePage={pageState}
                            itemsCountPerPage={onePageSizeState}
                            totalItemsCount={totPstdCntState}
                            pageRangeDisplayed={5}
                            firstPageText={""}
                            linkClassFirst={"pagenationBtn pagenationFirstBtn"}
                            prevPageText={""}
                            linkClassPrev={"pagenationBtn pagenationPrevBtn"}
                            nextPageText={""}
                            linkClassNext={"pagenationBtn pagenationNextBtn"}
                            lastPageText={""}
                            linkClassLast={"pagenationBtn pagenationLastBtn"}
                            onChange={handlePageChange}
                        />
                    </div>
                    </>:
                    <><p className="noDataLi tCenter mt25">{langData&&langData.GLB_NO_DATA_LBL_00}</p></>
                }
            </div>
        </div>
        </div>
    )
}
export default CtntPstdLstUi;